import { useRouter } from 'next/router'
import { useEffect, PropsWithChildren, useRef } from 'react'

import { useIntercom } from './useIntercom'

export function IntercomProvider({ children }: PropsWithChildren) {
  const isInitialized = useRef(false)

  const router = useRouter()

  const intercom = useIntercom()

  useEffect(() => {
    if (!isInitialized.current) {
      intercom?.boot()
      intercom && (isInitialized.current = true)
    }
  }, [intercom])

  useEffect(() => {
    if (!window || !window.Intercom || !intercom) return

    const handleRouteChange = () => {
      intercom.updateForRouteChange()
    }

    router.events.on('routeChangeComplete', handleRouteChange)

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange)
    }
  }, [router, intercom])

  return <>{children}</>
}
